module.exports = __webpack_public_path__ + "static/media/icon-logoff.51f366cd.svg";